// @todo проверить, нужен ли этот eslint-disable
/* eslint-disable react-hooks/exhaustive-deps */

import React, { useEffect, useState } from "react";
import {
  Div,
  Panel,
  PanelHeader,
  ScreenSpinner,
  Button,
  Text,
  PanelHeaderContent,
} from "@vkontakte/vkui";
import styles from "./ChooseDatePanel.style";
import { setActivePanel, setPreviousPanel } from "../../redux/actions/panelsActions";
import { cleanNameSelector } from "../../redux/actions/doctorsActions";
import globalSCSS from "../../styles/styles.module.scss";

import { panels } from "../../variables";
import { connect } from "react-redux";
import { startDatesLoading } from "../../redux/actions/datesActions";
import { getReadableDate } from "../../utils";
import DatesTable from "./DatesTable";
import ChooseTime from "./ChooseTime/ChooseTime";
import ChooseDateHeader from "./ChooseDateHeader/ChooseDateHeader";
import stylesChooseDateHeader from "./ChooseDateHeader/ChooseDateHeader.style";
import { startEqueueBooking } from "../../redux/actions/equeuesActions";
import Icon28ArrowLeftOutline from "@vkontakte/icons/dist/28/arrow_left_outline";
import {
  splitTwoWeekByMonth,
  getAvailableDatesFromSlots,
  generateTwoWeeks,
} from "./helpers";

const ChooseDatePanel = ({
  id,
  showDatesLoader,
  error,
  showBookingLoader,
  goBack,
  startDatesLoading,
  slots,
  orderId,
  sessionId,
  selectedSlot,
  selectedMedicalOrganisation,
  selectedRegion,
  selectedDoctorName,
  selectedDoctorSpeciality,
  userInfo,
  startEqueueBooking,
  isConfirming,
  enteredOms,
  goBackMoscow,
}) => {
  const [firstMonth, setFirstMonth] = useState([]);
  const [secondMonth, setSecondMonth] = useState([]);
  const [firstDay, setFirstDay] = useState(1);
  const [availableDates, setAvailableDates] = useState([]);

  const date = new Date();
  // дата начала для тестов
  //let date = new Date('May 20, 2021');
  const days = generateTwoWeeks(date);

  useEffect(() => {
    if (!slots) {
      startDatesLoading(
        selectedMedicalOrganisation,
        selectedDoctorName,
        selectedDoctorSpeciality,
        sessionId,
        getReadableDate(days[0]),
        getReadableDate(days[13]),
        orderId
      );
    }
  }, []);

  useEffect(() => {
    if (slots && slots.length && !firstMonth.length) {
      setAvailableDates(getAvailableDatesFromSlots(slots));
      const [first, second] = splitTwoWeekByMonth(days);
      setFirstMonth(first);
      setSecondMonth(second);

      // можно установить календарь ВСЕГДА с понедельника
      //setFirstDay(1);

      setFirstDay(days[0].getDay());
    }
  }, [slots]);

  const isClickable = Boolean(selectedSlot) && !showBookingLoader && !isConfirming;

  return (
    <Panel id={id}>
      <PanelHeader
        separator={false}
        left={
          <Icon28ArrowLeftOutline
            onClick={() => {
              selectedRegion.regionCode === "77" ? goBackMoscow() : goBack();
            }}
            fill={"#06844D"}
          />
        }
      >
        <PanelHeaderContent
          className="headerText"
          style={styles.widthHeaderText}
        >
          Выбор даты и времени
        </PanelHeaderContent>
      </PanelHeader>

      {isConfirming ? (
        <Div style={styles.spinner}>
          <ScreenSpinner />
        </Div>
      ) : (
        <div style={styles.conatainer}>
          <ChooseDateHeader />

          {showDatesLoader ? (
            <Div style={styles.spinner}>
              <ScreenSpinner />
            </Div>
          ) : (
            <div style={styles.containerInfo}>
              {error ? (
                <Text weight={"regular"} style={stylesChooseDateHeader.wrapper}>
                  {error.errorDetail.errorMessage}
                </Text>
              ) : (
                <Div style={styles.calendar}>
                  <DatesTable
                    dates={firstMonth}
                    availableDates={availableDates}
                    firstDay={firstDay}
                  />
                  <DatesTable
                    dates={secondMonth}
                    availableDates={availableDates}
                    firstDay={firstDay}
                  />
                </Div>
              )}
              <ChooseTime />
            </div>
          )}

          <Button
            disabled={!isClickable}
            size="l"
            className={globalSCSS['button']}
            onClick={() => {
              startEqueueBooking(
                selectedSlot,
                sessionId,
                selectedMedicalOrganisation,
                selectedRegion,
                orderId,
                selectedDoctorName,
                selectedDoctorSpeciality,
                userInfo,
                enteredOms
              );
            }}
          >
            Записаться
          </Button>
        </div>
      )}
    </Panel>
  );
};
const mapStateToProps = (state) => {
  return {
    showDatesLoader: state.loader.showDatesLoader,
    showBookingLoader: state.loader.showBookingLoader,
    isConfirming: state.loader.showConfirmLoader,
    orderId:
      state.regionAndMedicalOrganisation.orderId ||
      state.moscowScenario.orderId,
    sessionId: state.userInfo.userInfo.sessionId,
    error: state.dates.error,
    slots: state.dates.slots,
    selectedSlot: state.dates.selectedSlot,
    selectedMedicalOrganisation:
      state.regionAndMedicalOrganisation.selectedMedicalOrganisation ||
      state.moscowScenario.medicalOrganisation,
    selectedRegion: state.regionAndMedicalOrganisation.selectedRegion,
    selectedDoctorName:
      state.doctors.selectedDoctorName ||
      state.moscowScenario.selectedDoctorName,
    selectedDoctorSpeciality:
      state.doctors.selectedDoctorSpeciality ||
      state.moscowScenario.selectedSpeciality,
    userInfo: state.userInfo.userInfo,
    enteredOms: state.oms.enteredOms,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    goBack: () => {
      dispatch(cleanNameSelector());
      dispatch(setPreviousPanel());
    },

    goBackMoscow: () =>
      dispatch(setActivePanel(panels.moscowRegionDoctorPanel)),
    startDatesLoading: (...args) => dispatch(startDatesLoading(...args)),
    startEqueueBooking: (...args) => dispatch(startEqueueBooking(...args)),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(ChooseDatePanel);
